export const appVersion = {
  release: "v1.0.0",
  stream: "Community Release",
  channel: "Beta",
};
